export default __webpack_public_path__ + "static/segment-stats-a529a7c6ad826005ca53a39e55534fc7.png";